export function productKey(p) {
  return String(p?.product_id || p?.variant_id || p?.id || "");
}

export function isFavoriteProductByIds(product, favoriteIds = []) {
  const key = productKey(product);
  return !!key && favoriteIds.includes(key);
}

export function closeProductSheet(setProductOpen, setSheetProduct) {
  setProductOpen(false);
  setSheetProduct(null);
}

export function closeAllOverlays({
  setCartOpen,
  setProductOpen,
  setSheetProduct,
  setCatalogOpen,
  setPresetModalOpen,
  setDeliveryOpen,
  setAwaitingCheckout,
}) {
  setCartOpen(false);
  setProductOpen(false);
  setSheetProduct(null);
  setCatalogOpen(false);
  setPresetModalOpen(false);
  setDeliveryOpen(false);
  setAwaitingCheckout(false);
}